import React from "react";

const Check = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M20.4866 20.4866C25.1711 15.802 25.1711 8.19802 20.4866 3.51344C15.802 -1.17115 8.19802 -1.17115 3.51344 3.51344C-1.17115 8.19802 -1.17115 15.802 3.51344 20.4866C8.19802 25.1711 15.802 25.1711 20.4866 20.4866ZM19 8.68203L12.0344 15.318L10.2758 17L8.51718 15.318L5 11.9539L6.75859 10.2719L10.2758 13.6359L17.2414 7L19 8.68203Z" fill="#00D1CA" />
  </svg>
)

export default Check